import { Directive, Input, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, Validators, AbstractControl, ValidatorFn } from '@angular/forms';

import { CovalentValidators } from '../validators';

export const /** @type {?} */ MIN_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => TdMinValidator),
  multi: true,
};
export class TdMinValidator implements Validator {
private _validator: ValidatorFn;
/**
 * @param {?} min
 * @return {?}
 */
set min(min: number) {
    this._validator = CovalentValidators.min(min);
  }
/**
 * @param {?} c
 * @return {?}
 */
validate(c: AbstractControl): {[key: string]: any} {
    return this._validator(c);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[min][formControlName],[min][formControl],[min][ngModel]',
  providers: [ MIN_VALIDATOR ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'min': [{ type: Input, args: ['min', ] },],
};
}

function TdMinValidator_tsickle_Closure_declarations() {
/** @type {?} */
TdMinValidator.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdMinValidator.ctorParameters;
/** @type {?} */
TdMinValidator.propDecorators;
/** @type {?} */
TdMinValidator.prototype._validator;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
